import { FC } from 'react';

import Table from 'modules/_shared/Table';
import NotesSectionTableHeader from './NotesSectionTableHeader';
import NotesSectionTableBody from './NotesSectionTableBody';

const NotesSectionTable: FC = () => {
  const tableContent = (
    <>
      <NotesSectionTableHeader />
      <NotesSectionTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default NotesSectionTable;
